import React from 'react';
import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import {
  LISTING_MODAL_ICON_BTN_SX,
  LISTING_MODAL_SAVE_BTN_DESTRUCTIVE_SX,
  LISTING_MODAL_SAVE_BTN_SX,
  LISTING_MODAL_TITLE_BAR_SX,
} from './listingModalGlassStyles';

/**
 * iOS-style listing modal header — close (left), title (center), confirm check (right).
 */
const ListingModalTitleBar = ({
  title,
  subtitle = null,
  onClose,
  onSave = null,
  saving = false,
  saveDisabled = false,
  saveAriaLabel = 'Save',
  destructive = false,
}) => {
  const saveSx = destructive ? LISTING_MODAL_SAVE_BTN_DESTRUCTIVE_SX : LISTING_MODAL_SAVE_BTN_SX;
  const showSave = typeof onSave === 'function';

  return (
    <Box sx={LISTING_MODAL_TITLE_BAR_SX}>
      <IconButton
        aria-label="Close"
        onClick={onClose}
        disabled={saving}
        sx={LISTING_MODAL_ICON_BTN_SX}
      >
        <CloseIcon />
      </IconButton>

      <Box sx={{ minWidth: 0, textAlign: 'center', px: 0.5 }}>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 600, lineHeight: 1.25 }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            sx={{
              fontSize: '0.78rem',
              color: 'rgba(0,0,0,0.5)',
              mt: 0.35,
              lineHeight: 1.35,
            }}
            noWrap
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>

      {showSave ? (
        <IconButton
          aria-label={saving ? 'Saving' : saveAriaLabel}
          onClick={onSave}
          disabled={saving || saveDisabled}
          sx={saveSx}
        >
          {saving ? (
            <CircularProgress
              size={20}
              sx={{ color: destructive ? 'rgba(185,28,28,0.85)' : 'rgba(0,103,102,0.85)' }}
            />
          ) : (
            <CheckIcon />
          )}
        </IconButton>
      ) : (
        <Box sx={{ width: 44 }} aria-hidden />
      )}
    </Box>
  );
};

export default ListingModalTitleBar;
